<div class="title">
  <mat-icon>receipt</mat-icon>
  Statement of Work
</div>
<div class="description">SELECT THE SOWS TO FILTER BY</div>

<div class="options">
  @for (sow of sows$ | async; track sow) {
    <elements-filter-chip
      icon="receipt"
      [caption]="sow.name"
      [selected]="isSelected(sow)"
      (click)="isSelected(sow) ? remove(sow) : add(sow)"
      [suffixIcon]="isSelected(sow) ? 'close' : undefined"
      >
    </elements-filter-chip>
  }
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
